import { TableCell, TableRow, Checkbox } from "@material-ui/core";
import React from "react";
import IAPI from "../../../../models/IAPI";

export interface IAPISelectRowProps {
  api: IAPI;
  isSelected: boolean;
  onAPIToggle: (api: IAPI, add: boolean) => void;
}

function IntegrationAPISelectRow(props: IAPISelectRowProps) {
  const { api, isSelected, onAPIToggle } = props;

  const onCheckboxChange = (event: React.ChangeEvent, checked: boolean) => {
    onAPIToggle(api, checked);
  };

  return (
    <TableRow key={api.ID}>
      <TableCell>
        <Checkbox checked={isSelected} onChange={onCheckboxChange} />
      </TableCell>
      <TableCell>{api.Name}</TableCell>
      <TableCell>{api.Method.Name}</TableCell>
      <TableCell>{api.Description}</TableCell>
    </TableRow>
  );
}

export default IntegrationAPISelectRow;
